/**
 * @generated SignedSource<<cee9b4ba77b6f278e65ee1f80d95e82b>>
 * @relayHash ea55d5f4f4544030c53603707767028e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ad90d78376d2c7b40ba96246b7a86ebb19f7038599f8cacbfbe9898ad397fc50

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { AgentContextQuery } from './AgentContextQuery.graphql';

const node: PreloadableConcreteRequest<AgentContextQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "ad90d78376d2c7b40ba96246b7a86ebb19f7038599f8cacbfbe9898ad397fc50",
    "metadata": {},
    "name": "AgentContextQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
